export default {
  'front': [
    {
      'id': 1,
      'name': 'React',
      'icon': 'devicon-react-original',
      'desc': 'UI layer with Context API, routing, and reusable components'
    },
    {
      'id': 2,
      'name': 'TypeScript + Webpack + Babel + Sass',
      'icon': 'devicon-sass-original',
      'desc': 'Typed frontend code, bundling, transpilation, and styling'
    },
    {
      'id': 3,
      'name': 'Semantic UI React',
      'icon': 'devicon-css3-plain',
      'desc': 'Design system and UI components'
    }
  ],

  'back': [
    {
      'id': 4,
      'name': 'Node.js',
      'icon': 'devicon-nodejs-plain',
      'desc': 'Runtime for the API service'
    },
    {
      'id': 5,
      'name': 'Fastify + GraphQL Yoga',
      'icon': 'devicon-nodejs-plain',
      'desc': 'Modern HTTP server and GraphQL execution layer'
    },
    {
      'id': 6,
      'name': 'Prisma',
      'icon': 'devicon-prisma-plain',
      'desc': 'Type-safe ORM and migrations for PostgreSQL'
    },
    {
      'id': 7,
      'name': 'PostgreSQL',
      'icon': 'devicon-postgresql-plain',
      'desc': 'Relational database for pictures, labels, users, and stats'
    }
  ]
}
